import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DropdownModule } from 'primeng/dropdown';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { UserAction } from './state/user.action';
import { UserEffects } from './state/user.effects';
import { STORE_FEATURE_KEY_USERS, UsersReducer } from './state/user.reducers';
import { UserSelectors } from './state/user.selectors';
import { UserService } from './state/user.service';
import { UserSearchComponent } from './user-search.component';
import { AccountSettingModule } from '../account-setting/account-setting.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TypeaheadModule.forRoot(),
        TooltipModule.forRoot(),
        DropdownModule,
        TabMenuModule,
        TabViewModule,
        TranslateModule,
        StoreModule.forFeature(STORE_FEATURE_KEY_USERS, UsersReducer),
        EffectsModule.forFeature([UserEffects]),
        ReactiveFormsModule,
        AccountSettingModule
    ],
    declarations: [
        UserSearchComponent
        ],
    providers: [
        UserService,
        UserSelectors,
        UserAction
        ],
    exports: [
        UserSearchComponent
    ]
})
export class UserModule {
}
